// hooks
import { Fragment, useCallback, useEffect, useState } from "react";
import useHttp from "hooks/use-http";

// routes
import { useNavigate } from "react-router-dom";

// material style
import { Grid } from "@mui/material";

// request method
import {
  getUsersMessagesRequest,
  deleteUserMessageByIdRequest,
} from "api/requests/messages";

// components
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import NotFound from "components/shared/NotFound/NotFound";
import MessageCard from "components/MessageCard";
import PaginationCM from "components/shared/Pagination";

// constants
import { PAGINATION_LIMIT } from "constants";

// helper
import Toast from "helper/toast";

// styled component
import { StyledStack, StyledTitle } from "./message.style";
import DeleteModal from "components/shared/Modal/Delete";

export default function Messages() {
  const navigate = useNavigate();

  const { request, loading, setLoading } = useHttp(false);

  // state for pagination
  const [page, setPage] = useState(1);

  // message data state
  const [messages, setMessages] = useState({ data: [], count: 0 });

  // delete modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  //handle delete modal
  const handelShowModal = () => setShowDeleteModal((state) => !state);
  const [delelteItemId, setDeleteItemId] = useState();

  // delete message method
  const onDelete = async (id) => {
    const res = await request({
      url: deleteUserMessageByIdRequest,
      values: id,
    });
    if (res) {
      Toast({ type: "success", title: "حذف پیام " });
      handelShowModal();
      getMessagesInfo();
    }
  };

  // get messages data method
  const getMessagesInfo = useCallback(async () => {
    const res = await request({
      url: getUsersMessagesRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT,
        limit: PAGINATION_LIMIT,
      },
    });
    if (res) {
      let transformedData = res.data.data.map((items) => ({
        id: items.id,
        title: items.title,
        full_name: items.full_name,
        email: items.email,
        phone_number: items.phone_number,
        message: items.message,
        is_seen: items.is_seen,
      }));
      setMessages({
        data: transformedData,
        count: res.data.count,
      });
    }
  }, [page]);

  useEffect(() => {
    getMessagesInfo();
  }, [page]);

  return (
    <DrawerCM title="پیام های کاربران">
      {loading ? (
        <LoadingCM />
      ) : messages.count < 1 ? (
        <NotFound title={"هیچ اطلاعاتی یافت نشد"} />
      ) : (
        <Fragment>
          <StyledStack>
            <StyledTitle>پیام های دریافتی</StyledTitle>
            <Grid
              container
              spacing={0}
              justifyContent="center"
              alignItems="center"
            >
              {messages.count < 1
                ? "هیچ اطلاعاتی یافت نشد"
                : messages.data.map((item, index) => (
                    <Grid item md={11} xs={12} p={1} key={index}>
                      <MessageCard
                        index={index}
                        item={item}
                        click={() => navigate("/messages/details/" + item.id)}
                        delete={() => {
                          setDeleteItemId(item.id);
                          handelShowModal();
                        }}
                      />
                    </Grid>
                  ))}
            </Grid>
          </StyledStack>
          <Grid
            container
            spacing={0}
            alignItems="center"
            justifyContent="center"
          >
            {messages.count < 1 ? (
              ""
            ) : (
              <PaginationCM
                handleChange={(e, val) => setPage(val)}
                page={page}
                count={messages.count}
              />
            )}
          </Grid>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={onDelete.bind(null, delelteItemId)}
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
